<div class="patch-upload-wrapper modal-main-wrapper">
    <div class="close-container" tabindex="1">
        <div class="img-container">
            <img src="../../../../../assets/icons/Close.svg"  (click)="cancel()">
        </div>
    </div>

    <div class="content-wrapper">
        <div *ngIf="showSuccessContainer" class="success-container">
            <div class="img-success-container">
                <img height="40" width="40" src="../../../../assets/icons/Done.svg" alt="success">
            </div>
            <div class="error-text-container">
                <span>{{"serviceKeySetSuccessfully" | transloco}}</span>
            </div>
        </div>
        <div *ngIf="!showSuccessContainer" class="error-container">
            <div class="img-error-container">
                <img height="40" width="40" src="../../../../assets/icons/icon-warning.svg" alt="warning"/>
            </div>
            <div class="error-text-container">
                <span>{{"errorSettingServiceKey" | transloco}}</span>
            </div>
        </div>
    </div>
    

    <footer>
        <div class="button-wrapper">            
            <button type="button" class="action-btn white-text cancel-button" (click)="cancel()" tabindex="7">
                OK
            </button>
        </div>
    </footer>
</div>